import styles from './styles.module.scss'

interface IBannerProps {
  title: string;
  description: string;
}

export const Banner: React.FC<IBannerProps> = ({ title, description }) => {
  return (
    <div className={styles.banner}>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  )
}
